/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatientCensus } from '../models/PatientCensus';
import { request as __request } from '../core/request';

export class PatientCensusService {

    /**
     * Get census list
     * @returns PatientCensus Census List
     * @throws ApiError
     */
    public static async getPatientCensus({
companyId,
start,
end,
}: {
companyId: number,
/** Start date (YYYY-MM-DD or RFC3339) **/
start?: string,
/** End date (YYYY-MM-DD or RFC3339) **/
end?: string,
}): Promise<Array<PatientCensus>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/patient-census`,
            query: {
                'start': start,
                'end': end,
            },
        });
        return result.body;
    }

    /**
     * Update Patient Census of a date
     * @returns PatientCensus Shift updated
     * @throws ApiError
     */
    public static async updatePatientCensus({
companyId,
requestBody,
}: {
companyId: number,
requestBody: PatientCensus,
}): Promise<PatientCensus> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/patient-census`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Add patient census
     * @returns PatientCensus Patient Census Created
     * @throws ApiError
     */
    public static async addPatientCensus({
companyId,
requestBody,
}: {
companyId: number,
requestBody: PatientCensus,
}): Promise<PatientCensus> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/patient-census`,
            body: requestBody,
        });
        return result.body;
    }

}